import { render } from "./UserRoleManagement.vue?vue&type=template&id=22264d7b&ts=true"
import script from "./UserRoleManagement.vue?vue&type=script&lang=ts"
export * from "./UserRoleManagement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__